// A ‘.tsx’ file enables JSX support in the TypeScript compiler, 
// for more information see the following page on the TypeScript wiki:
// https://github.com/Microsoft/TypeScript/wiki/JSX

import React from 'react';
interface IfProps extends OptionalHtmlProps {
    condition: boolean;
}

const If = (props: IfProps) => (
    props.condition
        ? <div style={props.styles} className={props.class}>{props.children}</div>
        : null
);

export default If;